import { ArrowUp } from "lucide-react";
import { scrollToId } from "./Navbar";
import { useLang } from "../i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-ink border-t border-steelborder blueprint-grid">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center mb-5">
              <img src="/brand/logo-dark.png" alt="ZTS F-Invest s.r.o." data-testid="footer-logo" className="h-16 w-auto" />
            </div>
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
              {t("footer_desc")}
            </p>
          </div>

          <div className="font-mono text-xs text-slate-500 space-y-2">
            <p className="font-heading text-sm font-bold uppercase tracking-widest text-slate-300 mb-3">{t("f_data")}</p>
            <p>{t("f_reg1")}</p>
            <p>{t("f_reg2")}</p>
            <p>IČO: 36319015 · DIČ: 2020116109 · IČ DPH: SK 2020116109</p>
          </div>

          <div className="flex md:justify-end items-start">
            <button onClick={() => scrollToId("#top")} data-testid="back-to-top-button"
              className="group flex items-center gap-3 border border-steelborder text-slate-400 font-mono text-xs tracking-[0.2em] uppercase px-5 py-3 hover:border-safety hover:text-safety transition-colors duration-300">
              {t("back_top")}
              <ArrowUp className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-1" />
            </button>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-steelborder flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono text-xs text-slate-600">© {new Date().getFullYear()} ZTS F-Invest s.r.o. {t("rights")}</p>
          <p className="font-mono text-xs text-slate-600">{t("loc")}</p>
        </div>
      </div>
    </footer>
  );
};
